import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiError } from '~/services/errors/JsonApiError';
import { atlas } from '~/services/serviceInstances';

import {
  UpdatePlaybookApiArg,
  UpdatePlaybookResponse,
} from '../../types/playbooks/playbooks';

export const updatePlaybook = async ({
  playbookId,
  updatePlaybookRequest,
}: UpdatePlaybookApiArg): Promise<UpdatePlaybookResponse> => {
  try {
    return await atlas.patch(`playbooks/${playbookId}`, updatePlaybookRequest);
  } catch (err: unknown) {
    if (err instanceof JsonApiError && err.errors.length > 0) {
      const error = err.errors[0];
      const statusCode = parseInt(error.status);
      if (statusCode >= 400 && statusCode < 500) {
        throw createCodedError({
          message: error.detail,
          statusCode,
        });
      }
    }

    throw err;
  }
};
